export interface Testimonial {
  name: string;
  role: string;
  content: string;
  avatar: string;
}

export const aboutData = {
  brandName: "好色小姨故事集",
  tagline: "都市情感故事的深度解读平台",
  intro: "「好色小姨故事集」是国内首个专注于都市言情小说中「好色小姨」经典角色类型的文学分析与内容分享平台。我们致力于通过深度的人物分析、精彩的故事情节梳理和专业的创作指导，为都市言情小说爱好者与创作者提供最有价值的内容。",
  story: "我们的团队由一群热爱都市言情文学的内容创作者组成。在阅读了数百本都市言情小说之后，我们发现「好色小姨」这一角色类型蕴含着极为丰富的文学价值和讨论空间。遗憾的是，市面上一直缺少一个专门聚焦于这一角色的深度内容平台。于是，「好色小姨故事集」应运而生。我们希望通过专业的分析和精心的内容策划，帮助读者更深入地理解这一角色的魅力，同时也为小说创作者提供实用的创作指导。",
  values: [
    {
      title: "深度解读",
      description: "不满足于表面的情节复述，我们追求对角色心理、文学价值和社会意义的深度挖掘。",
      icon: "ri-search-eye-line",
    },
    {
      title: "专业视角",
      description: "融合文学批评、心理学和社会学等多学科视角，提供专业而有洞见的内容分析。",
      icon: "ri-award-line",
    },
    {
      title: "创作赋能",
      description: "不仅为读者提供阅读指引，更为创作者提供实用的写作方法论和创作灵感。",
      icon: "ri-quill-pen-line",
    },
    {
      title: "开放包容",
      description: "尊重多元观点，鼓励理性讨论，拒绝简单的道德评判，拥抱复杂的人性思考。",
      icon: "ri-hand-heart-line",
    },
  ],
  stats: [
    { value: "50+", label: "深度解析文章" },
    { value: "200万+", label: "累计阅读量" },
    { value: "10万+", label: "忠实读者" },
    { value: "4", label: "核心内容板块" },
  ],
  testimonials: [
    {
      name: "林小雨",
      role: "都市言情小说作者",
      content: "作为一个写了五年都市言情小说的作者，「好色小姨故事集」给了我太多的创作灵感。特别是那篇关于角色塑造的指南，直接帮我重新设计了正在连载中的一个关键角色。这个平台是真的懂创作的。",
      avatar: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20portrait%2C%20warm%20lighting%2C%20soft%20expression%2C%20professional%20headshot%2C%20literary%20style%2C%20cream%20background%2C%20natural%20look%2C%20editorial%20photography&width=200&height=200&seq=avatar-01&orientation=squarish",
    },
    {
      name: "陈思远",
      role: "文学爱好者",
      content: "一开始是被朋友推荐的，结果一看就停不下来了。那些人物分析文章写得真的好，不是简单地说谁好谁坏，而是真正在探讨人性和情感的复杂性。作为一个普通读者，读完之后对整个都市言情小说类型都有了新的认识。",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20friendly%20smile%2C%20casual%20style%2C%20cream%20background%2C%20natural%20look%2C%20editorial%20photography&width=200&height=200&seq=avatar-02&orientation=squarish",
    },
    {
      name: "王晓婷",
      role: "网络文学编辑",
      content: "作为从业者，我看过太多质量参差不齐的网络文学内容。好色小姨故事集是少数能让我真正觉得「有营养」的平台。它既保持了专业深度，又不会让人觉得晦涩难懂，这种平衡感非常难得。",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20warm%20lighting%2C%20confident%20expression%2C%20business%20casual%2C%20cream%20background%2C%20editorial%20photography%2C%20natural%20look&width=200&height=200&seq=avatar-03&orientation=squarish",
    },
  ],
  contactEmail: "contact@haosexiaoyi.com",
  contactWechat: "haosexiaoyi2026",
  socialLinks: {
    weibo: "https://weibo.com/haosexiaoyi",
    wechat: "haosexiaoyi2026",
    zhihu: "https://zhihu.com/column/haosexiaoyi",
  },
};

export const testimonials: Testimonial[] = aboutData.testimonials;